import { CircularProgress } from '@material-ui/core'
import React, { FC, useCallback } from 'react'

import { useDispensaryTestKitRequest } from '../../../../lib/dispensaries/hooks/useDispensaryTestKitRequest'
import { DispensaryData } from '../../../../lib/dispensaries/types'
import * as Styled from './styled'

export interface RequestTestKitCallToActionProps {
  dispensary: DispensaryData
  productSku: string
}

export const RequestTestKitCallToAction: FC<RequestTestKitCallToActionProps> = ({
  dispensary,
  productSku,
}) => {
  const [requestDispensaryTestKit, { loading, data, error }] = useDispensaryTestKitRequest()
  const requestTestKit = useCallback(
    async () => requestDispensaryTestKit({ dispensarySlug: dispensary.slug, sku: productSku }),
    [requestDispensaryTestKit, dispensary.slug, productSku],
  )

  if (loading) {
    return (
      <Styled.Container>
        <Styled.Button disabled>
          <CircularProgress size={14} color="inherit" />
        </Styled.Button>
      </Styled.Container>
    )
  }
  return (
    <Styled.Container>
      <Styled.Button onClick={requestTestKit} disabled={!loading && !!data && !error}>
        Request a Test
      </Styled.Button>
      {data && (
        <Styled.SuccessfulRequestToast $fadeIn>
          <b>Test requested</b>
          <br />
          We’ve notified your practitioner and they will get in touch soon.
        </Styled.SuccessfulRequestToast>
      )}
      {error && (
        <Styled.ErrorRequestToast $fadeIn>
          There was an error requesting this Spotlight Test.
        </Styled.ErrorRequestToast>
      )}
    </Styled.Container>
  )
}
